import { className } from '@empori/util';
import * as React from 'react';
import { useSwiper } from 'swiper/react';
export function TestimonialSlide(props) {
    var item = props.item;
    return (React.createElement("div", { className: className('testimonial-slide-item element-flex', { active: true }) },
        React.createElement("div", { className: 'outer-content' },
            React.createElement("div", { className: 'inner-content' },
                React.createElement("div", { className: 'quoter element-flex' },
                    React.createElement("div", { className: 'quoter-info bullet-subheader' },
                        React.createElement("p", null,
                            item.quoter,
                            ", ",
                            item.titleAndCompany))),
                React.createElement("h2", { className: 'quote' },
                    "\"",
                    item.quote,
                    "\"")))));
}
export function SwiperArrow(props) {
    var swiper = useSwiper();
    if (props.totalSlides <= 1) {
        return null;
    }
    return (React.createElement("div", { className: className("swiper-arrow swiper-".concat(props.direction), { disabled: props.activeIndex === 0 }) },
        React.createElement("div", { className: 'arrow', onClick: function () {
                if (props.direction === 'left') {
                    swiper.slidePrev();
                    return;
                }
                swiper.slideNext();
            } },
            React.createElement("i", { className: "fa-light fa-chevron-".concat(props.direction) }))));
}
export function ThumbnailItem(props) {
    var swiper = useSwiper();
    var handleClick = function () {
        props.updateIndex(props.index);
        swiper.slideTo(props.index + 1);
    };
    return (React.createElement("div", { className: className('thumbnail-item', { active: props.activeIndex === props.index }), onClick: function () { return handleClick(); } },
        React.createElement("div", { className: 'dot' })));
}
